import React from 'react';
import './PreviewSite.css';
import BoutonPaiement from './BoutonPaiement';

// ══════════════════════════════════════════════════════════════
// PreviewSite v4.0 — L'APERÇU EST LE SITE PUBLIÉ
// ──────────────────────────────────────────────────────────────
// Ce composant n'a PLUS son propre moteur de rendu. Il affiche le
// HTML RÉEL produit par generateurHTML.js (renvoyé par le backend
// dans `apercuHtml`), dans une iframe.
//
// Conséquence : l'aperçu est identique au site publié, et il suit
// AUTOMATIQUEMENT toutes les futures améliorations du générateur
// (formulaires par secteur, moyens de paiement, etc.) — sans qu'on
// ait jamais à modifier ce fichier. Fini les deux versions qui
// divergent.
//
// Le composant ne garde que l'habillage du wizard : la barre du
// haut, le récap SEO, et le bloc de publication (BoutonPaiement).
// ══════════════════════════════════════════════════════════════

export default function PreviewSite({ contenu, apercuHtml, onRetour, siteId, statut = 'brouillon' }) {
  // Tant qu'aucun site n'est généré, on ne s'affiche PAS DU TOUT — sinon
  // l'aperçu resterait collé en bas du wizard pendant toutes les étapes.
  // On n'apparaît qu'une fois qu'il y a quelque chose à montrer.
  if (!apercuHtml && !contenu) return null;

  // On lit juste le nom et le SEO pour l'habillage — le rendu du
  // site lui-meme vient entierement de `apercuHtml`.
  let data = {};
  try {
    if (contenu && typeof contenu === 'object') {
      data = contenu;
    } else if (typeof contenu === 'string') {
      data = JSON.parse(
        contenu.replace(/```json\n?/g, '').replace(/```\n?/g, '').trim()
      );
    }
  } catch (e) {
    data = {};
  }

  const meta = data.meta || {};
  const seo = data.seo || {};
  const nomOrg = meta.nom_organisation || 'Votre site';

  return (
    <div className="preview-container">
      <div className="preview-topbar">
        <div className="preview-topbar-left">
          <span className="preview-dot rouge"></span>
          <span className="preview-dot jaune"></span>
          <span className="preview-dot vert"></span>
          <span className="preview-url">Prévisualisation — {nomOrg}</span>
        </div>
        <div className="preview-topbar-right">
          <span className="preview-badge">✨ Aperçu réel du site</span>
        </div>
      </div>

      <div className="preview-info-banner">
        📌 <strong>Aperçu fidèle</strong> — Ce que vous voyez ici est
        exactement votre site publié. Naviguez entre les pages, ouvrez les
        formulaires : tout se comporte comme en ligne.
      </div>

      {apercuHtml ? (
        <iframe
          className="preview-iframe"
          title={`Aperçu — ${nomOrg}`}
          srcDoc={apercuHtml}
          sandbox="allow-scripts allow-popups allow-popups-to-escape-sandbox"
        />
      ) : (
        <div className="preview-erreur">
          <h3>⏳ Aperçu indisponible</h3>
          <p>
            L'aperçu n'a pas pu être chargé. Revenez en arrière et relancez la
            génération.
          </p>
          <button type="button" onClick={onRetour}>← Retour</button>
        </div>
      )}

      {seo.meta_titre && (
        <div className="preview-seo">
          <h4>📊 Informations SEO générées</h4>
          <div className="seo-grid">
            <div className="seo-item">
              <span className="seo-label">Titre SEO</span>
              <span className="seo-value">{seo.meta_titre}</span>
            </div>
            <div className="seo-item">
              <span className="seo-label">Description</span>
              <span className="seo-value">{seo.meta_description}</span>
            </div>
            <div className="seo-item">
              <span className="seo-label">Mots-clés</span>
              <span className="seo-value">
                {Array.isArray(seo.mots_cles) ? seo.mots_cles.join(', ') : ''}
              </span>
            </div>
          </div>
        </div>
      )}

      {statut === 'brouillon' && (
        <div className="preview-paiement">
          <div className="paiement-header">
            <h3>🎉 Votre site est prêt !</h3>
            <p>
              Choisissez votre formule et publiez votre site. Il sera en ligne
              en 24 h max.
            </p>
          </div>

          <BoutonPaiement mode="plans" siteId={siteId} />

          <button type="button" className="btn-regenerer" onClick={onRetour}>
            🔄 Modifier et régénérer
          </button>
        </div>
      )}
    </div>
  );
}